import { handleErrorInfo } from '../../utils';
import { SplitPaymentsActionType } from './actions';
import { SplitPaymentState } from './interfaces';

const initialState: SplitPaymentState = {
  loading: true,
  formLoading: false,
  error: false,
  errorInfo: undefined,
  allSplitPayments: undefined,
  requestSuccess: false,
  step: 0,
  collaboratorEmailValidated: false,
  createSplitPaymentPayload: undefined,
  collaborationIdSelected: undefined,
  exportType: undefined,
  export: {
    loading: false,
    error: false,
    errorInfo: undefined,
    show: false,
    data: undefined,
  },
};

const SplitPaymentsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SplitPaymentsActionType.GET_SPLIT_PAYMENTS: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
      };
    }
    case SplitPaymentsActionType.GET_SPLIT_PAYMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: {},
        allSplitPayments: {
          ...action.response,
        },
      };
    }
    case SplitPaymentsActionType.GET_SPLIT_PAYMENTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: null,
      };
    }
    case SplitPaymentsActionType.POST_CREATE_SPLIT_PAYMENT: {
      return {
        ...state,
        formLoading: true,
        error: false,
        errorInfo: undefined,
      };
    }
    case SplitPaymentsActionType.POST_CREATE_SPLIT_PAYMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        formLoading: false,
        error: false,
        errorInfo: null,
        requestSuccess: true,
        allSplitPayments: {
          ...state.allSplitPayments,
        },
      };
    }
    case SplitPaymentsActionType.INVITE_TO_COLLABORATE: {
      return {
        ...state,
        step: 1,
        error: false,
        errorInfo: undefined,
      };
    }
    case SplitPaymentsActionType.SELECT_USER_TYPE: {
      return {
        ...state,
        createSplitPaymentPayload: {
          userType: action.userType,
        },
      };
    }
    case SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR: {
      return {
        ...state,
        error: false,
        errorInfo: undefined,
        collaboratorEmailValidated: false,
        createSplitPaymentPayload: {
          ...state.createSplitPaymentPayload,
          ...action.payload,
        },
      };
    }
    case SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR_SUCCESS: {
      return {
        ...state,
        error: false,
        step: 4,
        errorInfo: undefined,
        collaboratorEmailValidated: true,
      };
    }
    case SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR_ERROR: {
      return {
        ...state,
        error: true,
        errorInfo: handleErrorInfo(SplitPaymentsActionType.VALIDATE_MERCHANT_COLLABORATOR_ERROR, action.error),
        collaboratorEmailValidated: false,
      };
    }
    case SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION: {
      return {
        ...state,
        error: false,
        errorInfo: undefined,
        loading: true,
        requestSuccess: false,
      };
    }
    case SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION_SUCCESS: {
      return {
        ...state,
        error: false,
        errorInfo: undefined,
        loading: false,
        requestSuccess: true,
      };
    }
    case SplitPaymentsActionType.PERFORM_COLLABORATION_ACTION_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        collaboratorEmailValidated: false,
      };
    }
    case SplitPaymentsActionType.SELECT_COLLABORATION: {
      return {
        ...state,
        collaborationIdSelected: action.id,
      };
    }
    case SplitPaymentsActionType.SHOW_EXPORT_SPLITS: {
      return {
        ...state,
        export: {
          ...state.export,
          show: action.show,
          ...(action.show
            ? {
                loading: false,
                error: false,
                errorInfo: undefined,
                data: undefined,
              }
            : {}),
        },
      };
    }
    case SplitPaymentsActionType.EXPORT_SPLITS: {
      return {
        ...state,
        exportType: action.exportType,
        export: {
          ...state.export,
          loading: true,
          error: false,
          errorInfo: undefined,
          data: undefined,
        },
      };
    }
    case SplitPaymentsActionType.EXPORT_SPLITS_SUCCESS: {
      return {
        ...state,
        export: {
          ...state.export,
          loading: false,
          data: action.response.text,
        },
      };
    }
    case SplitPaymentsActionType.EXPORT_SPLITS_ERROR: {
      return {
        ...state,
        export: {
          ...state.export,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(SplitPaymentsActionType.EXPORT_SPLITS_ERROR, action.error),
        },
      };
    }
    default:
      return state;
  }
};

export default SplitPaymentsReducer;
